import { createAction, props } from '@ngrx/store';
import { PartyListWidgetStateModel } from '../../AppState';
import { PaginationModel } from '../../models/pagination-models';

export const getAssetPartiesRequest = createAction('[Parties] Get Asset Parties Request', props<{ paginationModel: PaginationModel, assetId: string, dataSourceId: string, pageId: string, widgetId: string }>());
export const getAssetPartiesDone = createAction('[Parties] Get Asset Parties Done', props<{ stateModel: PartyListWidgetStateModel, dataSourceId: string }>());
export const getAssetPartiesError = createAction('[Parties] Get Asset Parties Error', props<{ stateModel: PartyListWidgetStateModel, dataSourceId: string }>());
export const resetPartyList = createAction('[Parties] Reset Party List');
